



































































import {Component, Mixins, Vue} from 'vue-property-decorator';
import MenuItemComponent from '@/components/layouts/base/MenuItemComponent.vue';
import User from '@/models/User';
import SecurityModule from '@/store/modules/SecurityModule';
import {ResponsiveMixin} from '@/mixins/ResponsiveMixin';
@Component({
  components: {MenuItemComponent}
})
export default class MenuComponent extends Mixins(ResponsiveMixin) {
  user: User = SecurityModule.getUser!!;
}
